import { Capacitor } from '@capacitor/core';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (Capacitor.isNativePlatform()) return;
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

/** Remove only the native WebView's old PWA worker/cache before OTA startup. */
export async function prepareNativeServiceWorker() {
  if (!Capacitor.isNativePlatform()) return;
  let timer;
  try {
    const cleanWorkers = async () => {
      if (!('serviceWorker' in navigator)) return;
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(async (registration) => {
        const worker = registration.active || registration.waiting || registration.installing;
        if (!worker) return;
        const script = new URL(worker.scriptURL, window.location.href);
        if (script.origin === window.location.origin && script.pathname === '/service-worker.js') {
          await registration.unregister();
        }
      }));
    };
    const cleanCaches = async () => {
      if (!('caches' in window)) return;
      const names = await window.caches.keys();
      await Promise.all(names.filter((name) => /^laeebly-v\d+$/.test(name)).map((name) => window.caches.delete(name)));
    };
    // Cleanup is safe to finish late; an unavailable WebView API cannot stall
    // React startup or consume the native rollback readiness deadline.
    await Promise.race([
      Promise.allSettled([cleanWorkers(), cleanCaches()]),
      new Promise((resolve) => { timer = setTimeout(resolve, 1500); }),
    ]);
  } catch (error) {
    console.warn('[Live updates] Native PWA cleanup unavailable:', error);
  } finally {
    clearTimeout(timer);
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
